module.exports = __webpack_public_path__ + "static/media/YF74_03.61b6d59c.jpg";